import { memo } from 'react';
import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';

import { useWorkflow } from '../v2-hooks/useWorkflow';
import { AuthorDraftStatePanel } from './AuthorDraftStatePanel';
import { AuthorQualityCheckStatePanel } from './AuthorQualityCheckStatePanel';
import { AuthorPublisherReviewStatePanel } from './AuthorPublisherReviewStatePanel';

export const AuthorStatePanel = memo(function AuthorStatePanel() {
  const workflow = useWorkflow();
  const draftState = workflow?.draftState;

  if (draftState === WorkflowState.PUBLISHER_REVIEW) {
    return <AuthorPublisherReviewStatePanel />;
  }
  if (draftState === WorkflowState.QUALITY_CHECK) {
    return <AuthorQualityCheckStatePanel />;
  }
  return <AuthorDraftStatePanel />;
});
